// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_CsRAD {
  position: relative;
  color: rebeccapurple;
  text-decoration: underline;
}

.text_CsRAD:hover::before {
  content: "Variantizer";
  font-size: 8px;
  position: absolute;
  top : -80%;
  left : 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/customText/textEditor/extensions/LevTextMark.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV","sourcesContent":[".text {\n  position: relative;\n  color: rebeccapurple;\n  text-decoration: underline;\n}\n\n.text:hover::before {\n  content: \"Variantizer\";\n  font-size: 8px;\n  position: absolute;\n  top : -80%;\n  left : 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `text_CsRAD`
};
export default ___CSS_LOADER_EXPORT___;
